export default "/assets/ico-toggle-on.png";